import { render } from "./TextPropertyControl.vue?vue&type=template&id=73c2a721&scoped=true"
import script from "./TextPropertyControl.vue?vue&type=script&lang=js"
export * from "./TextPropertyControl.vue?vue&type=script&lang=js"

import "./TextPropertyControl.vue?vue&type=style&index=0&id=73c2a721&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c2a721"]])

export default __exports__